import { IUiIcon } from '../../../types/ui'

export const IconSlash = (
	{
		size = 24,
		imgSize = 24,
		fill = 'none',
		stroke = 'currentColor'
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-slash"
		>
			<circle cx="12" cy="12" r="10"></circle>
			<line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
		</svg>
	)
}